import * as React from 'react';
import { useEndSession } from 'hooks/useEndSession';

import Header, { IHeaderProps } from './Header';

export type IHeaderContainerProps = Omit<IHeaderProps, 'endSessionCallback'>;

const HeaderContainer: React.FC<IHeaderContainerProps> = (props) => {
  const onEndSession = useEndSession();

  return <Header {...props} onEndSession={onEndSession} />;
};

export default HeaderContainer;
